import type { ChatbotConversationsPageSize } from '../../types/userConfig';

export type ChatbotConversationsListOptions = {
  limit: number;
  offset: number;
};

export function parseConversationsPageFromSearchParams(
  searchParams: URLSearchParams,
): number {
  const rawPage = Number(searchParams.get('page') ?? '1');
  if (!Number.isFinite(rawPage) || rawPage < 1) {
    return 1;
  }
  return Math.floor(rawPage);
}

export function buildConversationsSearchParams(page: number): URLSearchParams {
  const params = new URLSearchParams();
  if (page > 1) {
    params.set('page', String(page));
  }
  return params;
}

export function buildConversationsListOptions(
  page: number,
  pageSize: ChatbotConversationsPageSize,
): ChatbotConversationsListOptions {
  return {
    limit: pageSize,
    offset: (page - 1) * pageSize,
  };
}
